<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5"
          >{{ !selectCategoria ? "Agregar" : "Editar" }} Categoría</label
        >
      </header>
      <form [formGroup]="formCategoria" (ngSubmit)="onOperarCategoria()">
        <div class="form-group">
          <label class="small text-secondary" for="nit">Descripción</label>
          <input
            id="descripcion"
            formControlName="descripcion"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit">Estado</label>
          <select
            class="form-control form-control-sm"
            id="activo"
            formControlName="activo"
            [attr.disabled]="!selectCategoria ? '' : null"
          >
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">Activo</option>
            <option class="" [ngValue]="0" [selected]="false">Inactivo</option>
          </select>
        </div>
        <div class="form-group">
          <label class="small text-secondary" for="nit"
            >Permitir cambio de subcategoría</label
          >
          <select
            class="form-control form-control-sm"
            id="activo"
            formControlName="tipo_permiso"
          >
            <option [ngValue]="'0'" selected="true">Ninguna</option>
            <option [ngValue]="'1'" [selected]="false">Actualización</option>
            <option [ngValue]="'2'" [selected]="false">Renovación (Reactivacion+Renovacion)</option>
            <option [ngValue]="'3'" [selected]="false">
              Actualización y Renovación (Reactivacion+Renovacion)
            </option>
          </select>
        </div>
        <div class="form-group form-check">
          <input
            id="permite_cambio_categoria"
            formControlName="permite_cambio_categoria"
            type="checkbox"
            class="form-check-input"
            (change)="onChangePermitirCambioCategoria()"
          />
          <label
            class="small text-secondary form-check-label"
            for="permite_cambio_categoria"
            >Permite cambio de categoría</label
          >
        </div>
        <div *ngIf="isOnPermitirCambioCategoria">
          <div class="form-group">
              <label for="listado_categoria" class="small text-secondary" for="nit">Nuevas categorías</label>
              <mat-select class="form-control form-control-sm" id="listado_categoria" 
                formControlName="listado_categoria" multiple disableOptionCentering>
                <mat-option #allSelected (click)="toggleAllSelection()" [value]="0">
                  TODAS LAS CATEGORIAS
                </mat-option>
                <mat-option *ngFor="let item of listadoCategorias; let i = index" [id]="i" [value]="item?.categoria_id">
                  {{item?.descripcion}}
                </mat-option>
              </mat-select>
          </div>

          <div class="form-group">
            <label
              class="small text-secondary"
              for="fecha_inicio_cambio_categoria"
              >Fecha inicio</label
            >
            <input
              id="descripcion"
              formControlName="fecha_inicio_cambio_categoria"
              type="date"
              class="form-control form-control-sm"
            />
            <div *ngIf="fecha_inicio_cambio_categoria.invalid && !fecha_inicio_cambio_categoria.untouched"
                  class="invalid-feedback"> 
                  {{requiredMessage}}
            </div>
          </div>
          <div class="form-group">
            <label class="small text-secondary" for="fecha_fin_cambio_categoria"
              >Fecha fin</label
            >
            <input
              id="fecha_fin_cambio_categoria"
              formControlName="fecha_fin_cambio_categoria"
              type="date"
              class="form-control form-control-sm"
            />
            <div *ngIf="fecha_fin_cambio_categoria.invalid && !fecha_fin_cambio_categoria.untouched"
                  class="invalid-feedback"> 
                  {{requiredMessage}}
            </div>
          </div>

          <div class="form-group form-check">
            <input
              id="obligatorio_actualizacion"
              formControlName="obligatorio_actualizacion"
              type="checkbox"
              class="form-check-input"
            />
            <label
              class="small text-secondary form-check-label"
              for="obligatorio_actualizacion"
              >Obligatorio actualización</label
            >
          </div>

          <div class="form-group form-check">
            <input
              id="obligatorio_renovacion"
              formControlName="obligatorio_renovacion"
              type="checkbox"
              class="form-check-input"
            />
            <label
              class="small text-secondary form-check-label"
              for="obligatorio_renovacion"
              >Obligatorio renovación (Reactivacion+Renovacion)</label
            >
          </div>

          <div class="form-group" *ngIf="this.selectCategoria">
            <label
              class="small text-secondary"
              for="titulo_mensaje_permitir_cambio_categoria"
              >Titulo Mensaje de cambio de categoría</label
            >
            <input type="text"
            id="mensaje_permitir_cambio_categoria"
            formControlName="titulo_mensaje_permitir_cambio_categoria"
            class="form-control form-control-sm">
            <div *ngIf="titulo_mensaje_permitir_cambio_categoria.invalid && !titulo_mensaje_permitir_cambio_categoria.untouched"
                  class="invalid-feedback"> 
                  {{requiredMessage}}
            </div>
            <label
              class="small text-secondary"
              for="mensaje_permitir_cambio_categoria"
              >Mensaje de cambio de categoría</label
            >
            <textarea
              rows="3"
              id="mensaje_permitir_cambio_categoria"
              formControlName="mensaje_permitir_cambio_categoria"
              class="form-control form-control-sm"
            ></textarea>
            <div *ngIf="mensaje_permitir_cambio_categoria.invalid && !mensaje_permitir_cambio_categoria.untouched"
                  class="invalid-feedback"> 
                  {{requiredMessage}}
            </div>
          </div>
        </div>
        <div class="form-row mt-5">
          <button
            type="button"
            class="btn btn-outline-primary border-0 m-auto"
            (click)="limpiarCategoria()"
          >
            Limpiar
          </button>
          <button
            class="btn btn-primary m-auto"
            [disabled]="!formCategoria.valid"
            type="submit"
          >
            {{ !selectCategoria ? "Agregar" : "Editar" }}
          </button>
        </div>
      </form>
    </section>

    <section class="col-9 p-4 mt-5 mb-5">
      <div class="d-flex justify-content-between">
        <div>
          <img
            src="../../../../../assets/icons/solicitud.png"
            class="d-inline-block img-responsive mr-3"
            alt=""
          />
          <label class="h5">Listado de Categorías</label>
        </div>
        <p>
          <button
            type="button"
            class="btn btn-outline-primary"
            (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed"
            aria-controls="filtros"
          >
            Ver filtros
          </button>
        </p>
      </div>

      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit"
                    >Descripción</label
                  >
                  <input
                    id="descripcion"
                    formControlName="descripcion"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Estado</label>
                  <select
                    class="form-control form-control-sm"
                    id="activo"
                    formControlName="activo"
                  >
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Activo
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      Inactivo
                    </option>
                  </select>
                </div>

                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit"
                    >Permite cambios de subcategoría en el formulario</label
                  >
                  <select
                    class="form-control form-control-sm"
                    id="tipo_permiso"
                    formControlName="tipo_permiso"
                  >
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      Ninguna
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Actualización
                    </option>
                    <option class="" [ngValue]="2" [selected]="false">
                      Renovación (Reactivacion+Renovacion)
                    </option>
                    <option class="" [ngValue]="3" [selected]="false">
                      Actualización y Renovación (Reactivacion+Renovacion)
                    </option>
                  </select>
                </div>
                <div class="d-flex flex-row">
                  <button
                    type="reset"
                    class="btn btn-outline-primary border-0 m-auto"
                    (click)="limpiar()"
                  >
                    Limpiar
                  </button>
                  <button
                    class="btn btn-primary m-auto solicitud-btn-principal"
                    type="submit"
                  >
                    Filtrar
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <app-tablas
          [page]="paginaActual"
          [headers]="headerCategoria"
          [sizeData]="dataTabla.paging.totalItems"
          (paginado)="onPaginado($event)"
          class="table-responsive"
        >
          <tr *ngFor="let item of dataTabla.items; let i = index" class="small">
            <td>{{ item.descripcion }}</td>
            <td>{{ nombreOpcionesSubcategoria(item.tipo_permiso) }}</td>
            <td>{{ item.activo ? "Activo" : "Inactivo" }}</td>
            <td class="d-flex flex-row">
              <img
                src="../../../../../../../assets/icons/edit.png"
                class="pointer"
                alt=""
                height="25"
                (click)="onCargarCategoria(item)"
              />
              <img
                src="../../../../../../../assets/icons/delete.png"
                class="pointer"
                alt=""
                height="25"
                (click)="onEliminarCategoria(item)"
              />
            </td>
          </tr>
        </app-tablas>
      </div>
    </section>
  </article>
</main>
